import { render, staticRenderFns } from "./ScaleSlider.vue?vue&type=template&id=4b2a4a58&"
import script from "./ScaleSlider.vue?vue&type=script&lang=ts&"
export * from "./ScaleSlider.vue?vue&type=script&lang=ts&"
import style0 from "./ScaleSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports